import { styled } from "@/stitches/config"

export const SGridItem = styled("div", {})
